module.exports = __webpack_public_path__ + "assets/img/banner.7b1cc0a1.jpg";